// Navigation configuration used across the app
// This is used by Layout.js and AuthSuccess.js for consistent routing

export const getNavigationSections = (selectedBusiness, isAdmin) => {
  const businessLocationId = selectedBusiness?.locationId || selectedBusiness?.googleLocationId || selectedBusiness?.id;

  return [
    {
      section: 'AGENTUR',
      items: [
        { text: 'Übersicht', path: '/agency-overview' },
        { text: 'Alle Unternehmen', path: '/all-businesses' },
        { text: 'Alle Geschäftsprofile', path: '/all-business-profiles' },
        { text: 'Top Performer', path: '/top-performers' },
        { text: 'Keyword-Performance', path: '/keyword-performance' }
      ]
    },
    {
      section: selectedBusiness ? `BETRIEB - ${selectedBusiness.name || 'AUSWÄHLEN'}` : 'BETRIEB',
      items: [
        { text: 'Profil', path: businessLocationId ? `/profile/${businessLocationId}` : null },
        { text: 'Inhalte', path: businessLocationId ? `/posts/${businessLocationId}` : null },
        { text: 'Bewertungen', path: businessLocationId ? `/reviews/${businessLocationId}` : null },
        { text: 'Services', path: businessLocationId ? `/services/${businessLocationId}` : null },
        { text: 'Leistung', path: businessLocationId ? `/insights/${businessLocationId}` : null },
        { text: 'Sichtbarkeit', path: businessLocationId ? `/ranking/${businessLocationId}` : null },
        { text: 'Medien', path: businessLocationId ? `/medias/${businessLocationId}` : null },
        { text: 'Bericht', path: businessLocationId ? `/report/${businessLocationId}` : null }
      ]
    }
  ];
};

// Get all available navigation items (flattened)
export const getNavigationItems = (selectedBusiness, isAdmin) => {
  const sections = getNavigationSections(selectedBusiness, isAdmin);
  const items = sections.flatMap(sec => sec.items).filter(item => item.path);

  if (isAdmin) {
    items.push(
      { text: 'Benutzer', path: '/admin/users' },
      { text: 'Einstellungen', path: '/settings' }
    );
  }

  return items;
};

// Get first valid navigation path (agency page, no business-specific path)
export const getFirstNavigationPath = (selectedBusiness = null, isAdmin = false) => {
  const sections = getNavigationSections(selectedBusiness, isAdmin);

  // First AGENTUR item (doesn't require business selection)
  if (sections[0]?.items?.length > 0) {
    const firstItem = sections[0].items[0];
    if (firstItem.path) {
      return firstItem.path;
    }
  }

  // Fallback to dashboard
  return '/agency-overview';
};
